import angular from 'angular'

angular
  .module('ggs.gallery-overlay')
  .directive('ggsGalleryOverlay', GalleryOverlayDirective)

import { OVERLAY_CLASS } from '../utils/shared-constants'

function GalleryOverlayDirective(
  qh,
  domh,
  animate,
  DefineMethod,
  DefineHandler) {

  return {
    restrict: 'E',
    controller: GalleryOverlayController,
    bindToController: true,
    scope: {
      ggsShowsOverlay: '<'
    }
  }

  function GalleryOverlayController($scope) {
    const sign = 'galleryOverlay'
    const $ctrl = $scope.$ctrl = this
    $ctrl.wrapH = DefineHandler(sign)
    $ctrl.wrapM = DefineMethod(sign)
    const overlayElm = domh.find.byClass.notStrict(OVERLAY_CLASS)

    if (!overlayElm) {
      return
    }

    animate.showForce(overlayElm)

    $ctrl.wrapM('show', animate.makeShow(overlayElm))
    $ctrl.wrapM('hide', animate.makeHide(overlayElm))

    $ctrl.wrapH('changeHandler',
      qh.makeIfElse(
        $ctrl.ggsShowsOverlay,
        $ctrl.show,
        $ctrl.hide))

    $scope.$watch(
      $ctrl.ggsShowsOverlay,
      $ctrl.changeHandler)
  }
}
